module.exports = __webpack_public_path__ + "static/media/MD_TutorialSlides_10202020_18.5_Effects.1fd351a0.png";